import React, {Component} from 'react';
import actions from '../actions';
import entityActions from '../../entities/actions';
import sharedActions from '../../shared/actions';
import {connect} from 'react-redux';
import RolesForm from './../components/RolesForm';
import {I18n} from 'react-redux-i18n';
import _ from '../../shared/utils/ObjectUtils';

class RolesFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.roleId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.roleId),
            alert: {
                show: false
            },
            roleFormData: {
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                entity: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                permissionsList: {
                    value: [],
                    error: undefined,
                    required: true
                }
            }
        }
    }

    componentDidMount() {
        const {roleId, getEntityList, getRoleData, getPermissionsList} = this.props;

        getEntityList()

        if (roleId) {
            getRoleData(roleId);
        } else {
            getPermissionsList();
        }
        // Get Timezone and Languages ?
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if (nextProps.roleWasDeleted) {
                this.handleRoleDeleteSuccess()
            } else {
                this.handleRoleDeleteError(nextProps.error)
            }
        } else if (this.props.loadingCreateRequest && !nextProps.loadingCreateRequest){
            if (nextProps.roleWasCreated) {
                this.handleRoleCreateSuccess()
            } else {
                this.handleRoleCreateError(nextProps.error)
            }
        } else if (this.props.loadingEditRequest && !nextProps.loadingEditRequest){
            if (nextProps.roleWasEdited) {
                this.handleRoleEditSuccess()
            } else {
                this.handleRoleEditError(nextProps.error)
            }
        } else if (this.props.loadingGetRequest && !nextProps.loadingGetRequest) {
            this.handleRoleLoadingCompleted(nextProps.roleData);
        } else if (_.isNilOrEmpty(this.props.permissionsList) && !_.isNilOrEmpty(nextProps.permissionsList)) {
            this.setState({
                roleFormData: {
                    ...this.state.roleFormData,
                    permissionsList: nextProps.permissionsList
                }
            })
        }
    };

    handleRoleLoadingCompleted = roleData => {
        // if (roleData.entity) {
        //     this.props.getRoleList(roleData.entity)
        // }
        const { 
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        updateCustomTitle(roleData.name);
        updateCustomBreadcrumbs([{
            link: "/roles",
            name: I18n.t('routes.roles')
        }, {
            link: "/roles/" + roleData.id,
            name: roleData.name
        }]);

        this.setState({
            ...this.state,
            roleFormData: {
                ...this.state.roleFormData,
                ...Object.entries(roleData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.roleFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    };

    handleFieldChange = (id, value) => {
        this.setState({
            roleFormData: {
                ...this.state.roleFormData,
                [id]: {
                    ...this.state.roleFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.roleFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let {roleFormData} = this.state;
        let error = null;
        switch (key) {
            default:
                if (!_.isNilOrEmpty(roleFormData[key].error) &&
                    roleFormData[key].required &&
                    !_.isNilOrEmpty(roleFormData[key].value)) {
                    error = undefined;
                } else if (roleFormData[key].required &&
                    _.isNilOrEmpty(roleFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== roleFormData[key].error) {
            roleFormData[key].error = error;
            this.setState({
                roleFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let {editMode, roleFormData} = this.state;
        const {roleId, editRole, createRole} = this.props;
        let formHasErrors = false;

        _.forOwn(roleFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        })

        if (!formHasErrors) {

            let formDataToBeSubmitted = {};
            formDataToBeSubmitted.name = roleFormData.name.value;
            formDataToBeSubmitted.entity = roleFormData.entity.value;
            formDataToBeSubmitted.permissionsList = roleFormData.permissionsList.value;

            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('roles.alerts.edit.title'),
                        html: I18n.t('roles.alerts.edit.text', {role: formDataToBeSubmitted.name}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editRole(roleId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('roles.alerts.create.title'),
                        html: I18n.t('roles.alerts.create.text', {role: formDataToBeSubmitted.name}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createRole(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                roleFormData,
            });
        }
    };

    handleEditClick = () => {
        const {editMode} = this.state;
        const {roleData} = this.props;

        if (editMode) {
            this.setState({
                editMode: false,
                viewMode: true,
                roleFormData:
                    Object.entries(this.state.roleFormData).reduce((acc, keyValuePair) => {
                        return {
                            ...acc,
                            [keyValuePair[0]]: {
                                ...this.state.roleFormData[keyValuePair[0]],
                                value: roleData[keyValuePair[0]] ? roleData[keyValuePair[0]] : undefined,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    handleRoleEditSuccess = () => {
        const {
            roleFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('roles.alerts.edit.success.title'),
                html: I18n.t('roles.alerts.edit.success.text', {role: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleRoleEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('roles.alerts.edit.error.title'),
                html: error ? error : I18n.t('roles.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.hideAlert();
        this.props.resetRoleForm();
        this.props.history.push({
            pathname: '/roles',            
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    };

    handleDeleteClick = () => {
        const {roleId, deleteRole} = this.props;
        const {
            roleFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;
        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('roles.alerts.delete.title'),
                html: I18n.t('roles.alerts.delete.text', {role: name}),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteRole(roleId)
                }
            }
        })
    };

    handleRoleDeleteSuccess = () => {
        const {
            roleFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('roles.alerts.delete.success.title'),
                html: I18n.t('roles.alerts.delete.success.text', {role: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleRoleDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('roles.alerts.delete.error.title'),
                html: error? error : I18n.t('roles.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };


    handlePermissionChanged = (groupKeyToChange, permissionKeyToChange, newValue) => {
        this.setState(() => {
            let newPermissionsList = this.props.permissionsList.map(group => {
                if (group.groupKey === groupKeyToChange) {
                    let groupPermissions = group.permissions.map(permission => {
                        if (permission.name === permissionKeyToChange) {
                            return {
                                ...permission,
                                value: newValue
                            };
                        } else {
                            return permission;
                        }
                    });
                    group.permissions = groupPermissions;
                }
                return group;
            });
            return {
                ...this.state,
                roleFormData: {
                    ...this.state.roleFormData,
                    permissionsList: {
                        value: newPermissionsList
                    }
                }
            }
        })

    };

    handlePermissionGroupChanged = (groupKeyToChange, newValue) => {
        this.setState(() => {
            let newPermissionsList = this.props.permissionsList.map(group => {
                if (group.groupKey === groupKeyToChange) {
                    let groupPermissions = group.permissions.map(permission => {
                        return {
                            ...permission,
                            value: newValue
                        };
                    });
                    group.permissions = groupPermissions;
                }
                return group;
            });
            return {
                ...this.state,
                roleFormData: {
                    ...this.state.roleFormData,
                    permissionsList: {
                        value: newPermissionsList
                    }
                }
            }
        })
    };

    handleRoleCreateSuccess = () => {
        const {
            roleFormData: {
                name: {
                    value: name
                },
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('roles.alerts.create.success.title'),
                html: I18n.t('roles.alerts.create.success.text', {role: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleRoleCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('roles.alerts.create.error.title'),
                html: error ? error : I18n.t('roles.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const {createMode, editMode, viewMode, roleFormData, alert} = this.state;
        const {entityList, permissionsList, loadingDeleteRequest, loadingCreateRequest, loadingEditRequest} = this.props;

        return <RolesForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingCreateRequest || loadingEditRequest || loadingDeleteRequest
            }}

            roleFormData={roleFormData}
            entityList={entityList}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}

            handlePermissionChanged={this.handlePermissionChanged}
            handlePermissionGroupChanged={this.handlePermissionGroupChanged}

            permissionGroups={permissionsList ? permissionsList : []}


        />
    }
}

const mapStateToProps = ({rolesReducer, entitiesReducer}) => {
    return {
        roleData: rolesReducer.roleData,
        permissionsList: rolesReducer.permissionsList,
        entityList: entitiesReducer.entityList,

        loadingGetRequest: rolesReducer.loadingGetRequest,
        loadingCreateRequest: rolesReducer.loadingCreateRequest,
        roleWasCreated: rolesReducer.roleWasCreated,

        loadingDeleteRequest: rolesReducer.loadingDeleteRequest,
        roleWasDeleted: rolesReducer.roleWasDeleted,

        loadingEditRequest: rolesReducer.loadingEditRequest,
        roleWasEdited: rolesReducer.roleWasEdited,

        error: rolesReducer.error
    };
};

const mapDispatchToProps = {
    getRoleData: actions.getRoleData,
    createRole: actions.createRole,
    editRole: actions.editRole,
    deleteRole: actions.deleteRole,
    resetRoleForm: actions.resetRoleForm,
    getEntityList: entityActions.getEntityList,
    getPermissionsList: actions.getPermissionsList,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RolesFormContainer);
